<script setup>
import AppButton from '#/general/AppButton.vue'
import { useVModel } from '@vueuse/core'
const props = defineProps({ visible: Boolean })
const emit = defineEmits(['update:visible'])
const visible = useVModel(props, 'visible', emit)
</script>

<template lang="pug">
.solutions--cta
  img.solutions--cta-img(src="~assets/img/aboutUs/Ati_round.png")
  .solutions--cta-desc.gt-sm
    | «Das Potenzial Ihres Hauses lässt
    br
    | Ihnen keine Ruhe?
    br
    | Wir helfen Ihnen gerne weiter!»
  .solutions--cta-desc.lt-md «Das Potenzial Ihres Hauses lässt Sie nicht mehr ruhig schlafen? Wir helfen gerne weiter!»
  .solutions--cta-name Atilla Färber
  .solutions--cta-company Raumpionier
  app-button.solutions--cta-btn(
    label="Jetzt Kontakt aufnehmen"
    padding="12px 27px"
    @click="visible = !visible"
  )
</template>

<style lang="sass">
.solutions--cta
  display: flex
  flex-direction: column
  align-items: center
  @media screen and (min-width: 1024px)
    margin: 110px 0 130px
  @media screen and (max-width: 1024px)
    margin: 240px 0 75px
  .solutions--cta-img
    width: 200px
    border-radius: 100%
    margin-bottom: 40px
  .solutions--cta-desc
    font-weight: 500
    line-height: 125%
    text-align: center
    background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    background-clip: text
    margin-bottom: 20px
    @media screen and (min-width: 1024px)
      font-size: 34px
    @media screen and (max-width: 1024px)
      font-size: 24px
      max-width: 320px
  .solutions--cta-name
    font-weight: 700
    line-height: 125%
    text-align: center
    color: #1F47CD
    @media screen and (min-width: 1024px)
      font-size: 20px
    @media screen and (max-width: 1024px)
      font-size: 16px
  .solutions--cta-company
    font-weight: 400
    line-height: 125%
    text-align: center
    color: #21252E
    @media screen and (min-width: 1024px)
      margin-bottom: 37px
      font-size: 20px
    @media screen and (max-width: 1024px)
      margin-bottom: 50px
      font-size: 16px
  .solutions--cta-btn
    width: 320px
</style>
